import React, { useState } from 'react';
import LanguageCountrySelector from '../../../components/LanguageCountrySelector';

const BnplControlPanel = ({ ecmContent }) => {
  const { languageOptions, countryOptions } = ecmContent?.jsonObject || {};
  const [selectedLanguage, setSelectedLanguage] = useState({
    frontend: 'html',
    backend: 'javascript'
  });

  const handleSelectLanguage = (domain, value) => {
    setSelectedLanguage({ ...selectedLanguage, [domain]: value });
  };

  return (
    <LanguageCountrySelector
      languageOptions={languageOptions}
      countryOptions={countryOptions}
      selectedLanguage={selectedLanguage}
      handleSelectLanguage={handleSelectLanguage}
    />
  );
};

export default BnplControlPanel;
